import {Component, EventEmitter, Input, OnInit, Output, ViewChild, OnChanges,
  ChangeDetectorRef, AfterViewInit  } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import { RDDarkService } from './../dark.service';

@Component({
  selector: 'rd-text-editor',
  template: `<div id="wysiwyg" [class.rdDark]="dark">
  <div id="editButtons">
    <div class="buttonGroup">
      <button (click)="addTextStyle('italic')"><i class="fas fa-italic"></i></button>
      <button (click)="addTextStyle('bold')"><i class="fas fa-bold"></i></button>
      <button (click)="addTextStyle('underline')"><i class="fas fa-underline"></i></button>
      <button (click)="addTextStyle('strikethrough')"><i class="fas fa-strikethrough"></i></button>
      <button (click)="addTextStyle('subscript')"><i class="fas fa-subscript"></i></button>
      <button (click)="addTextStyle('superscript')"><i class="fas fa-superscript"></i></button>
    </div>

    <div class="buttonGroup">
      <button (click)="addTextStyle('justifyLeft')"><i class="fas fa-align-left"></i></button>
      <button (click)="addTextStyle('justifyCenter')"><i class="fas fa-align-center"></i></button>
      <button (click)="addTextStyle('justifyRight')"><i class="fas fa-align-right"></i></button>
      <button (click)="addTextStyle('justifyFull')"><i class="fas fa-align-justify"></i></button>
    </div>

    <div class="buttonGroup">
      <input [(ngModel)]="size" [style.width]="'30px'">
      <button (click)="changeFontSize()"><i class="fas fa-check"></i></button>
    </div>

    <div class="buttonGroup">
      <button (click)="addTextStyle('insertUnorderedList')"><i class="fas fa-list-ul"></i></button>
      <button (click)="addTextStyle('insertOrderedList')"><i class="fas fa-list-ol"></i></button>
      <button (click)="addTextStyle('indent')"><i class="fas fa-indent"></i></button>
      <button (click)="addTextStyle('outdent')"><i class="fas fa-outdent"></i></button>
    </div>

    <div class="buttonGroup">
      <button (click)="addTextStyle('undo')"><i class="fas fa-undo"></i></button>
      <button (click)="addTextStyle('redo')"><i class="fas fa-redo"></i></button>
    </div>

  </div>
  <div (keyup)="pushText()" class="editContent" [style.height.px]="height"
    #textEditor contenteditable="true" [innerHTML]="textTmp" (click)="handleClick($event)"></div>
</div>
`,
  styles: [`#wysiwyg{width:100%;max-width:100%;--text-color:black}#wysiwyg #editButtons{background-color:#07384c;border:1px solid #d3d3d3}#wysiwyg .buttonGroup{display:inline-block;margin:5px}#wysiwyg .buttonGroup>*{cursor:pointer;padding:6px 8px;background-color:#11506a;color:#fff;border-left:none;border-bottom:1px solid #d3d3d3;border-top:1px solid #d3d3d3;border-right:1px solid #d3d3d3}#wysiwyg .buttonGroup>:first-child{border-left:1px solid #d3d3d3;border-top-left-radius:6px;border-bottom-left-radius:6px}#wysiwyg .buttonGroup>:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}#wysiwyg .editContent{box-sizing:border-box;padding:6px;word-break:normal;width:100%;max-width:100%;border:1px solid #d3d3d3;height:200px;overflow-y:auto;display:inline-block;color:var(--text-color)!important}#wysiwyg.rdDark{--text-color:white}`]
})
export class RDTextEditorComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() text = '';
  @Input() height = 200;

  @Output() textChange: EventEmitter<any> = new EventEmitter();
  @Output() getSelection: EventEmitter<any> = new EventEmitter();

  @ViewChild('textEditor') textArea;

  public textTmp;
  public size = 17;
  public dark = false;

  constructor(private sanitize: DomSanitizer, public darkService: RDDarkService,
    private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  ngAfterViewInit() {
    this.cd.detach();
  }

  ngOnChanges(changes) {
    if (changes.text) {
      if (changes.text.currentValue !== this.textTmp) {
        this.textTmp = this.sanitize.bypassSecurityTrustHtml(this.text.slice());
        this.cd.detectChanges();
      }
    } else {
      this.cd.detectChanges();
    }
  }

  addTextStyle(style) {
    document.execCommand(style, false, '');
    this.textArea.nativeElement.focus();
    this.textChange.emit(this.textArea.nativeElement.innerHTML);
  }

  changeFontSize() {
    document.execCommand('fontSize', false, '7');
    const fontElements = this.textArea.nativeElement.getElementsByTagName('font');
    for (let i = 0, len = fontElements.length; i < len; ++i) {
      if (fontElements[i].attributes.getNamedItem('size')) {
        fontElements[i].removeAttribute('size');
        fontElements[i].style.fontSize = this.size + 'px';
      }
    }
    this.textArea.focus();
    this.textTmp = this.textArea.nativeElement.innerHTML;
    this.textChange.emit(this.textArea.nativeElement.innerHTML);
  }

  pushText() {
    this.textTmp = this.textArea.nativeElement.innerHTML;
    this.textChange.emit(this.textArea.nativeElement.innerHTML);
  }

  handleClick(event) {
    if (event.view.getSelection().type === 'Range')   {
      this.getSelection.emit(event.view.getSelection().toString());
    }
  }

}
